export const DownloadObjectId = 'Download';

export enum DownloadObjectAttributes {
  TITLE = 'title',
  BLOB = 'blob',
  TAGS = 'tags',
  VISIBLE_IN_SEARCH = 'visibleInSearch',
}
